/**
 * Outlined fields with solid label chip over the border — values no longer cover labels.
 * Props are forwarded to MUI TextField.
 */
/* eslint-disable react/prop-types */
import TextField from "@mui/material/TextField";
import { figmaTokens } from "assets/theme/designTokens";

const sxOutlined = {
  "& .MuiOutlinedInput-root": {
    bgcolor: figmaTokens.surface,
    borderRadius: "10px",
    minHeight: 48,
    "& fieldset": {
      borderColor: figmaTokens.borderSubtle,
    },
    "&:hover fieldset": {
      borderColor: figmaTokens.borderStrong,
    },
    "&.Mui-focused fieldset": {
      borderColor: figmaTokens.accent,
      borderWidth: "1px",
      boxShadow: `0 0 0 3px ${figmaTokens.focusRing}`,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: "13px",
    px: 1.25,
    fontSize: "0.875rem",
    boxSizing: "border-box",
  },
  "& .MuiInputLabel-root": {
    color: figmaTokens.textMuted,
    "&.Mui-focused": { color: figmaTokens.accent },
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    bgcolor: figmaTokens.surface,
    px: 0.65,
    ml: "2px",
    borderRadius: "6px",
    zIndex: 1,
  },
  "& .MuiFormHelperText-root": {
    mt: 0.5,
    mx: 0.25,
  },
};

function FilterTextField(props) {
  const { sx, InputProps, InputLabelProps, ...rest } = props;
  return (
    <TextField
      variant="outlined"
      fullWidth
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
      sx={{ ...sxOutlined, ...sx }}
      InputProps={{
        ...InputProps,
      }}
      {...rest}
    />
  );
}

export default FilterTextField;
